import React from 'react';
import { Form, Input, Typography, Select, Checkbox } from 'antd';
// Utils
import { USAGE_RIGHTS_SCOPE_OPTIONS } from 'helpers/customCampaignConstants';
// Style
import styles from './UsageRightsFields.module.scss';

const { Text } = Typography;
const { Option } = Select;

type UsageRightsFieldsProps = {
  noUsageRights: boolean;
  onUsageRightsChange: () => void;
};

const UsageRightsFields = ({
  noUsageRights,
  onUsageRightsChange,
}: UsageRightsFieldsProps): JSX.Element => {
  return (
    <div>
      <h4 className={styles.subSectionTitle}>Usage Rights</h4>
      <Form.Item name="usageRights" valuePropName="checked" noStyle>
        <Checkbox checked={noUsageRights} onChange={onUsageRightsChange}>
          No usage rights needed
        </Checkbox>
      </Form.Item>

      {!noUsageRights && (
        <div className={styles.usageRightsFields}>
          <Form.Item
            name="usageRightsDurationMonths"
            label={<Text>Duration (months)</Text>}
          >
            <Input
              type="number"
              placeholder="e.g. 6"
              aria-label="Usage rights duration in months"
            />
          </Form.Item>

          <Form.Item
            name="usageRightsScopes"
            label={<Text>Scopes</Text>}
            className={styles.usageRightsScopes}
          >
            <Select mode="multiple" placeholder="Select scopes" allowClear>
              {USAGE_RIGHTS_SCOPE_OPTIONS.map((item) => (
                <Option value={item.value} key={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>
      )}
    </div>
  );
};

export default UsageRightsFields;
